<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput
                    :options="fullNameInput.options"
                    :data="fullNameInput.data"
                  />
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <BaseSelect
                    :options="genderSelect.options"
                    :data="genderSelect.data"
                    ref="genderSelect"
                  >
                  </BaseSelect>
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput
                    :options="emailInput.options"
                    :data="emailInput.data"
                  />
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput
                    :options="userNameInput.options"
                    :data="userNameInput.data"
                  />
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <BaseSelect
                    :options="verifySelect.options"
                    :data="verifySelect.data"
                    ref="verifySelect"
                  >
                  </BaseSelect>
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <BaseSelect
                    :options="statusSelect.options"
                    :data="statusSelect.data"
                    ref="statusSelect"
                  >
                  </BaseSelect>
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <div class="form-group form-input-wrapper">
                    <label class="col-form-label">Roles *</label><br />
                    <div class="" style="display: inline-flex;">
                      <div
                        v-for="each in rolesInput.data.items"
                        :key="each.id"
                        class="custom-control custom-checkbox"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          v-model="rolesInput.data.model"
                          :value="each.id"
                          :id="each.id"
                        />
                        <label
                          class="custom-control-label mr-3"
                          :for="each.id"
                          >{{ each.name }}</label
                        >
                      </div>
                    </div>
                    <div
                      class="valid-error"
                      v-show="!rolesInput.data.validator.isValid"
                    >
                      {{ rolesInput.data.validator.errorMessage }}
                    </div>
                  </div>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-plus"></i> Thêm mới</CButton
                >
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.go(-1)"
                  ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import helper2 from '@/helper'
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import Vue from 'vue'

export default {
  name: "UserAdd",
  components: { BaseSelect, BaseInput, BaseLoading },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function() {
    var that = this;
    return {
      loading: { value: false },
      fullNameInput: {
        options: {
          label: "Tên đầy đủ *",
          placeholder: "Tên đầy đủ",
          type: "text"
        },
        data: {
          name: "fullName",
          model: "",
          updateCallback: function() {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function() {
              let value = that.fullNameInput.data.model;
              let fullname_regex = /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀẾỂưăạảấầẩẫậắằẳẵặẹẻẽềềếểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ ]+$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên đầy đủ không được để trống";
              } else if (value.length < 6) {
                this.isValid = false;
                this.errorMessage = "Tên đầy dủ ít nhất có 6 kí tự";
              } else if (fullname_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Tên đầy dủ chỉ gồm chữ cái và dấu cách";
              } else if (fullname_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      genderSelect: {
        options: {
          label: "Giới tính",
          filter: false
        },
        data: {
          name: "gender",
          items: [
            { key: "2", value: "Không xác định" },
            { key: "1", value: "Nam" },
            { key: "0", value: "Nữ" }
          ],
          model: "2"
        }
      },
      emailInput: {
        options: {
          label: "Email *",
          placeholder: "Email",
          type: "text"
        },
        data: {
          name: "email",
          model: "",
          updateCallback: function() {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function() {
              let value = that.emailInput.data.model;
              let email_regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Email không được để trống";
              } else if (email_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Email không đúng định dạng";
              } else if (email_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      userNameInput: {
        options: {
          label: "Tên đăng nhập *",
          placeholder: "Tên đăng nhập",
          type: "text"
        },
        data: {
          name: "userName",
          model: "",
          updateCallback: function() {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function() {
              let value = that.userNameInput.data.model;
              let username_regex = /^([a-zA-Z0-9 !%&@#$^*?_~]){6,}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên đăng nhập không được để trống";
              } else if (username_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage =
                  "Tên đăng nhập ít nhất 6 kí tự và là chữ thường";
              } else if (username_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      verifySelect: {
        options: {
          label: "Xác minh tài khoản",
          filter: false
        },
        data: {
          name: "isVerified",
          items: [
            { key: "0", value: "Chưa xác minh" },
            { key: "1", value: "Đã xác minh" }
          ],
          model: "0"
        }
      },
      statusSelect: {
        options: {
          label: "Trạng thái",
          filter: false
        },
        data: {
          name: "status",
          items: [
            { key: "0", value: "Tạm khóa" },
            { key: "1", value: "Hoạt động" }
          ],
          model: "1"
        }
      },
      rolesInput: {
        data: {
          name: "roles",
          model: [],
          items: [],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function() {
              let value = that.rolesInput.data.model;
              if (value === undefined || value.length === 0) {
                this.isValid = false;
                this.errorMessage = "Vui lòng chọn Role";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      }
    };
  },
  methods: {
    submitData: function() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/user/registerUserAccount",
        dataRef: function() {
          return that.$data;
        },
        successCallback: function(response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data)
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thêm mới tài khoản thành công"
            });
            that.$router.go(-1);
          }
        },
        errorCallback: function(error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    loadDataRoles: function() {
      var that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/user/getListRole",
        successCallback: function(response) {
          that.rolesInput.data.items = response.data.data;
        },
        errorCallback: function(error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.loadDataRoles();
  },
  watch: {
    'rolesInput.data.model' : function() {
      this.rolesInput.data.validator.valid();
    }
  }
};
</script>
